import { render, staticRenderFns } from "./stage-averages.vue?vue&type=template&id=f877acea&scoped=true&"
import script from "./stage-averages.vue?vue&type=script&lang=js&"
export * from "./stage-averages.vue?vue&type=script&lang=js&"
import style0 from "./stage-averages.vue?vue&type=style&index=0&id=f877acea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f877acea",
  null
  
)

component.options.__file = "stage-averages.vue"
export default component.exports